import utilsApi from '../assets/js/utils';
export default utilsApi.creatApi({
    // 获取当前用户指定的订单详情
    getCurrentUserShopOrderInfo: ["post", "getCurrentUserShopOrderInfo"],
});